import { createFileRoute } from '@tanstack/react-router';

import { filterState, TabularPageLoadingLayout } from '@/_containers';
import { getDomainsQueryOptions } from '@/_pages/domains/api-service';

export const Route = createFileRoute('/_private/domains/')({
  validateSearch: filterState.parse,
  staticData: { isFullWidth: true },
  loader: (opts) => opts.context.queryClient.ensureQueryData(getDomainsQueryOptions()),
  pendingComponent: () => <TabularPageLoadingLayout numberOfColumns={5} />,
});
